export const removeQueryParams = (url: string) => {
  const [path] = url.split("?");
  return path;
};
